import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { WHATSAPP_STATUS } from "../constants/constants";
import { serverUrl } from "./AssistantDetails/Assistants.utils";

export default function WhatsApp() {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState(WHATSAPP_STATUS.QR_PENDING);
  const [qrImage, setQrImage] = useState(null);

  const sessionId = searchParams.get("sessionId");
  const state = searchParams.get("state");

  useEffect(() => {
    if (!sessionId) return;

    let cancelled = false;

    const fetchQr = async () => {
      try {
        const qrRes = await fetch(`${serverUrl}/whatsapp/qr/${sessionId}`);
        const qrData = await qrRes.json();
        if (!cancelled && qrData?.qr) {
          setQrImage(qrData.qr);
        }
      } catch (err) {
        console.error("Failed to fetch QR", err);
      }
    };

    fetchQr();

    const interval = setInterval(async () => {
      try {
        const res = await fetch(`${serverUrl}/whatsapp/status/${sessionId}`);
        const data = await res.json();

        if (cancelled) return;
        setStatus(data.status);

        if (
          data.status === WHATSAPP_STATUS.QR_PENDING ||
          data.status === WHATSAPP_STATUS.QR_READY
        ) {
          await fetchQr();
        }

        if (data.status === WHATSAPP_STATUS.READY) {
          clearInterval(interval);
          window.location.href = `${serverUrl}/whatsapp/callback?state=${state}`;
        }
      } catch (err) {
        console.error("Failed to fetch WhatsApp status", err);
      }
    }, 3000);

    return () => {
      cancelled = true;
      clearInterval(interval);
    };
  }, [sessionId, state]);

  const isPending =
    status === WHATSAPP_STATUS.QR_PENDING ||
    status === WHATSAPP_STATUS.QR_READY;

  return (
    <div
      className="container d-flex flex-column align-items-center justify-content-center text-center my-5"
      style={{ minHeight: "80vh" }}
    >
      {isPending ? (
        <div className="card shadow-sm p-4" style={{ maxWidth: "420px" }}>
          <h4 className="mb-3">Scan QR with WhatsApp</h4>
          {qrImage ? (
            <img
              src={qrImage}
              alt="QR Code"
              className="img-fluid rounded mb-3 mx-auto"
              style={{ maxWidth: "250px" }}
            />
          ) : (
            <p className="text-muted small mb-3">Loading QR code...</p>
          )}
          <p className="text-muted small mb-0">
            Open WhatsApp → Linked Devices → Link a Device
          </p>
        </div>
      ) : (
        <div className="card shadow-sm p-4" style={{ maxWidth: "420px" }}>
          <i
            className="bi bi-arrow-repeat text-success"
            style={{ fontSize: "2.5rem", animation: "spin 1s linear infinite" }}
          />
          <p className="mb-0 fw-medium mt-3">Connected! Redirecting...</p>
        </div>
      )}
    </div>
  );
}